import { BiddingChatTypes } from './types';

interface CreateChatMessagesParams {
  content: string;
  biddingId: number;
  chatId: number;
  strategicQuestionId?: string;
}

export const fetchChat = (biddingId: number) => ({
  types: [
    BiddingChatTypes.FETCH_CHAT_REQUEST,
    BiddingChatTypes.FETCH_CHAT_SUCCESS,
    BiddingChatTypes.FETCH_CHAT_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/chatbots/bidding_chat/bidding_user_chats', {
      params: { conlicitacao_id: biddingId },
    }),
});

export const fetchChatMessages = (chatId: number) => ({
  types: [
    BiddingChatTypes.FETCH_CHAT_MESSAGES_REQUEST,
    BiddingChatTypes.FETCH_CHAT_MESSAGES_SUCCESS,
    BiddingChatTypes.FETCH_CHAT_MESSAGES_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/chatbots/bidding_chat/bidding_user_chat_messages', {
      params: { bidding_user_chat_id: chatId },
    }),
});

export const createChatMessages = (params: CreateChatMessagesParams) => {
  const { biddingId, chatId, content, strategicQuestionId } = params;

  return {
    types: [
      BiddingChatTypes.CREATE_CHAT_MESSAGE_REQUEST,
      BiddingChatTypes.CREATE_CHAT_MESSAGE_SUCCESS,
      BiddingChatTypes.CREATE_CHAT_MESSAGE_FAILURE,
    ],
    content,
    chatId,
    promise: (client: any) =>
      client.post('/chatbots/bidding_chat/bidding_user_chat_messages', {
        bidding_user_chat_id: chatId,
        conlicitacao_id: biddingId,
        content,
        ...(strategicQuestionId
          ? { strategic_question_id: strategicQuestionId }
          : {}),
      }),
  };
};

export const updateChatMessage = (id: number, rating: boolean) => {
  return {
    types: [
      BiddingChatTypes.UPDATE_CHAT_MESSAGE_REQUEST,
      BiddingChatTypes.UPDATE_CHAT_MESSAGE_SUCCESS,
      BiddingChatTypes.UPDATE_CHAT_MESSAGE_FAILURE,
    ],
    promise: (client: any) =>
      client.patch(`/chatbots/bidding_chat/bidding_user_chat_messages/${id}`, { rating }),
    rating,
    messageId: id,
  };
};

export const fetchUserQuestion = () => ({
  types: [
    BiddingChatTypes.FETCH_USER_QUESTION_REQUEST,
    BiddingChatTypes.FETCH_USER_QUESTION_SUCCESS,
    BiddingChatTypes.FETCH_USER_QUESTION_FAILURE,
  ],
  promise: (client: any) => client.get('/chatbots/bidding_chat/user_saved_questions'),
});

export const createUserQuestion = (content: string) => ({
  types: [
    BiddingChatTypes.CREATE_USER_QUESTION_REQUEST,
    BiddingChatTypes.CREATE_USER_QUESTION_SUCCESS,
    BiddingChatTypes.CREATE_USER_QUESTION_FAILURE,
  ],
  content,
  promise: (client: any) => client.post('/chatbots/bidding_chat/user_saved_questions', { content }),
});

export const updateUserQuestion = (content: string, id: number) => {
  return {
    types: [
      BiddingChatTypes.UPDATE_USER_QUESTION_REQUEST,
      BiddingChatTypes.UPDATE_USER_QUESTION_SUCCESS,
      BiddingChatTypes.UPDATE_USER_QUESTION_FAILURE,
    ],
    promise: (client: any) =>
      client.patch(`/chatbots/bidding_chat/user_saved_questions/${id}`, { content }),
    questionContent: content,
    questionId: id,
  };
};

export const deleteUserQuestion = (id: number) => ({
  types: [
    BiddingChatTypes.DELETE_USER_QUESTION_REQUEST,
    BiddingChatTypes.DELETE_USER_QUESTION_SUCCESS,
    BiddingChatTypes.DELETE_USER_QUESTION_FAILURE,
  ],
  promise: (client: any) => client.delete(`/chatbots/bidding_chat/user_saved_questions/${id}`),
  questionId: id,
});
